export const DataListHeader = (props) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
    <div style={{ flex: 1, paddingLeft: 50 }}>Frame:</div>
    <div style={{ flex: 3, paddingLeft: -50 }}>ステータス</div>
  </div>
);
